import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { AlertService } from '../../services/alert/alert.service';
import { RatesSroMasterService } from '../../services/rates-sro-master/rates-sro-master.service';
import { LoadingService } from '../../services/loading/loading.service';
import { BehaviorSubject, Observable, Subject, ReplaySubject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { FrtAccessorialsMasterService } from '../../services/frt-accessorials-master/frt-accessorials-master.service';
import { Units } from './units';
import AppConstants, {
  carrier_user,
  carrier_user_admin,
  system_admin,
} from '../../shared/common-components/AppConstants';
import * as _ from 'lodash';
import { HhgCarrierRateFilingService } from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {first, shareReplay, takeWhile, tap, distinctUntilChanged, switchMap, map, filter} from 'rxjs/operators';
import { UserService } from '../../services/user/user.service';
import { User } from '../../services/user/user';
import { HhgOnlineBookShipmentService } from '../hhg-online-book-shipment/hhg-online-book-shipment.service';
import { StateCountry } from '../../shared/common-components/common-structure';
import { StateCountryService } from '../../services/state-country/state-country.service';
import moment from 'moment';
import 'moment/locale/pt-br';
import { UserPreferencesService } from 'src/app/services/user-preferences/user-preferences.service';
import { UserPreference } from '../user-preferences/user-preference';
import { PrefItem } from '../user-preferences/pref-item';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-frt-rate-query',
    templateUrl: './frt-rate-query.component.html',
    styleUrls: ['./frt-rate-query.component.css'],
    standalone: false
})
export class FrtRateQueryComponent implements OnInit, OnDestroy {
  types: any = [
    { name: 'General', sroType: 'General' },
    { name: 'Alternating', sroType: 'Alternating' },
    { name: 'Emergency', sroType: 'Emergency' },
    { name: 'Fleet Line Vehicles Dom', sroType: 'Fleet Vehicles - Class 1: 1 – 5,999 GVWR (Domestic)' },
    { name: 'Fleet Line Vehicles Dom', sroType: 'Fleet Vehicles - Class 2: 6,000 – 11,999 GVWR (Domestic)' },
    { name: 'Fleet Line Vehicles Dom', sroType: 'Fleet Vehicles - Class 3: 12,000 and Over GVWR (Domestic)' },
    { name: 'Fleet Line Vehicles Intl', sroType: 'Fleet Vehicles - Class 1: 1 – 5,999 GVWR (International)' },
    { name: 'Fleet Line Vehicles Intl', sroType: 'Fleet Vehicles - Class 2: 6,000 – 11,999 GVWR (International)' },
    { name: 'Fleet Line Vehicles Intl', sroType: 'Fleet Vehicles - Class 3: 12,000 and Over GVWR (International)' },
  ];
  /*types: any = ['General', 'Alternating', 'Emergency', 'Fleetline Vehicles 1 - Domestic', 'Fleetline Vehicles 2 - Domestic', 'Fleetline Vehicles 3 - Domestic' +
  'Fleetline Vehicles 1 - International', 'Fleetline Vehicles 2 - International', 'Fleetline Vehicles 3 - International']; // Removed as per BL , 'Non-Alternating'*/
  sroIds: any = [];
  queryResult: any;
  showCountries = false;
  showOrigin = false;
  showDestination = false;
  showDestinationProvince = false;
  showOriginProvince = false;
  showInternational: boolean;
  isGssr: boolean;
  showCountry: boolean;
  showOriginCanadianProvince: boolean;
  showDestCanadianProvince: boolean;
  showSroId: boolean;
  isFleetLineVehicle: boolean;
  showAccessorials = true;
  showAccessorialsError: Boolean = false;
  showGssrError: Boolean = false;
  showQueryGrid: boolean;
  showOriginDestination: boolean;
  showOriginDestinationInput: boolean;
  originList = [];
  destinationList: any = [];
  queryResults$;
  accessorials: any;
  freightQueryForm: UntypedFormGroup;
  typeaheadOriginLoading: boolean;
  typeaheadDestinationLoading: boolean;
  dataSourceOrigin: Observable<any>;
  dataSourceDestination: Observable<any>;
  typeaheadLoading: any;
  tmssloader: any;
  minDate = new Date();
  currentUser: User;
  originCntryId: StateCountry;
  destnCntryId: StateCountry;
  userPref: UserPreference;
  userPrefList: PrefItem[];
  screenName: any;
  pickupDatePayLoad: any;
  estimatedMileage: any;
  format = 'yyyy-MM-dd HH:mm:ss';
  locale = 'en-US';
  weightRanking: any;
  estWeight: any;
  numVehicles: any;
  arrayFormControlAccessorials: any
  private observer$ = new BehaviorSubject(true);
  private canadaStateCountryId = new ReplaySubject<number>(1);
  private canadianProvinces = new BehaviorSubject<StateCountry>(null);
  allCountriesList$ = this.stateCountryService.getAllCountries().pipe(
    map(stateCountries => stateCountries.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1) ),
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );
  allCountriesFrtList$ = this.stateCountryService.getAllCountries().pipe(
    map(stateCountries => stateCountries.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1 && (country.parentCountryId === 365 || country.parentCountryId === 326)) ),
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );
  domesticCountriesList$ = this.stateCountryService.getDomesticCountries().pipe(
    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.domesticCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );
  provincesList$ = this.stateCountryService.getCanadaStates();

  private defaultCountry = new BehaviorSubject<StateCountry>(null);
  private domesticCountry = new BehaviorSubject<StateCountry>(null);


  constructor(private ratesSroMasterService: RatesSroMasterService,
              private formBuilder: UntypedFormBuilder, private alertService: AlertService,
              private frtAccessorialsMasterService: FrtAccessorialsMasterService,
              private loader: LoadingService, private onlineBookShipmentService: HhgOnlineBookShipmentService,
              private hhgrateService: HhgCarrierRateFilingService, private stateCountryService: StateCountryService,
              private userService: UserService, private userPreferencesService: UserPreferencesService) {
    this.minDate.setFullYear(this.minDate.getFullYear() - 6);
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncOriginSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
    this.dataSourceDestination = Observable.create((observer: any) => {
      this.ratesSroMasterService.getLocations(this.freightQueryForm.get('asyncDestinationSearchString').value)
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  /**
   * @description initializes the form and gets all the accessorials
   */
  ngOnInit() {
    this.queryResults$ = new BehaviorSubject(this.queryResult);
    this.showSroId = false;
    this.initializeForm();
    this.getAllAccesorials();
    this.onValueChanges();
  }

  /**
   * @description sorts state country list based on id
   */
  compareCountryFn(c1: StateCountry, c2: StateCountry) {
    return c1 && c2 ? c1.stateCountryId === c2.stateCountryId : c1 === c2;
  }

  /**
   * @description initializes frt query form.
   */
  initializeForm() {
    this.freightQueryForm = this.formBuilder.group({
      pickupDate: new FormControl(new Date(), Validators.required),
      sroType: new FormControl(null, Validators.required),
      sroId: new FormControl(null),
      estimatedWeight: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{1,8}?$')]),
      estimatedMileage: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+(.[0-9]{1,2})?$')]),
      numberOfVehicles: new FormControl(null, [Validators.required]),
      estimatedCuFt: new FormControl(null, [Validators.pattern('^[0-9]*$')]),
      originId: new FormControl(null, [Validators.required]),
      destinationId: new FormControl(null, [Validators.required]),
      originCountryId: new FormControl(null, [Validators.required]),
      destinationCountryId: new FormControl(null, [Validators.required]),
      asyncOriginSearchString: new FormControl(null),
      asyncDestinationSearchString: new FormControl(null),
      originProvince: new FormControl(null),
      destnProvince: new FormControl(null),
      accessorials: this.formBuilder.array([])
    });
  }

  /**
   * @description determines whether the abstract control is valid or not
   */
  isFormElementInValid(fullFormControlName: string) {
    const fromElement = this.freightQueryForm.get(fullFormControlName);
    return fromElement && fromElement.invalid &&
      fromElement.touched;
  }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  conditionalValidator(predicate, validator) {
    return (formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (predicate() === 'Fleet Line Vehicles Intl') {
        return validator(formControl);
      }
      return null;
    });
  }

  /**
   * listens to the changes of SRO type and gets the sroIdId's from the service; nullifies sroId, originId, destinationId, estimatedMileage form controls
   * as these values changes for every values.
   */
  onSroTypeChange(sroIdType, value) {
    // console.log(value);
    this.showSroId = false;
    this.sroIds = [];
    this.originList = [];
    this.destinationList = [];
    this.showQueryGrid = false;
    this.showOriginCanadianProvince = false;
    this.showDestCanadianProvince = false;
    this.showCountries = false;
    this.freightQueryForm.get('sroId').setValidators([]);
    this.freightQueryForm.get('sroId').setValue(null);
    if (sroIdType !== 'Fleet Line Vehicles Intl') {
      this.showOriginDestination = true;
      this.showOriginDestinationInput = true;
      this.showInternational = false;
      if (sroIdType === 'General' || sroIdType === 'Alternating') {
        this.freightQueryForm.get('originCountryId').setValidators([Validators.required]);
        this.freightQueryForm.get('destinationCountryId').setValidators([Validators.required]);
        this.showCountries = true;
      }
      this.clearValidators('originCountryId');
      this.clearValidators('destinationCountryId');
      this.freightQueryForm.get('originId').setValidators([Validators.required]);
      this.freightQueryForm.get('destinationId').setValidators([Validators.required]);
      this.freightQueryForm.get('estimatedMileage').setValidators([Validators.required]);
      this.freightQueryForm.get('originCountryId').setValidators([Validators.required]);
      this.freightQueryForm.get('destinationCountryId').setValidators([Validators.required]);
      this.freightQueryForm.get('originProvince').setValidators(null);
      this.freightQueryForm.get('destnProvince').setValidators(null);
      if (sroIdType === 'Alternating' || sroIdType === 'General' || sroIdType === 'Emergency') {
        this.defaultCountry
          .pipe(filter(value => value != null))
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(defaultCountry => {
            this.freightQueryForm.get('originCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
            this.freightQueryForm.get('destinationCountryId').setValue(defaultCountry, {emitEvent: false, onlySelf: false});
          });
      } else {
        this.domesticCountry
          .pipe(filter(value => value != null))
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(domesticCountry => {
            this.freightQueryForm.get('originCountryId').setValue(domesticCountry, {emitEvent: false, onlySelf: false});
            this.freightQueryForm.get('destinationCountryId').setValue(domesticCountry, {emitEvent: false, onlySelf: false});
          });
      }
    } else {
      this.showOriginDestination = false;
      this.showOriginDestinationInput = false;
      this.showInternational = true;
      this.showCountries = false;
      this.clearValidators('originId');
      this.clearValidators('destinationId');
      this.clearValidators('estimatedMileage');
      this.freightQueryForm.get('originCountryId').setValidators([Validators.required]);
      this.freightQueryForm.get('destinationCountryId').setValidators([Validators.required]);
      this.freightQueryForm.get('estimatedMileage').setValidators([Validators.required]);
      this.defaultCountry.pipe(filter(value => value != null))
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe(defaultCountry => {
          this.freightQueryForm.get('originCountryId').setValue(defaultCountry);
          this.freightQueryForm.get('destinationCountryId').setValue(defaultCountry);
        });
    }
    if (sroIdType === 'Alternating' || sroIdType === 'General' || sroIdType === 'Emergency' ||
      sroIdType === 'Fleet Line Vehicles Dom' || sroIdType === 'Fleet Line Vehicles Intl') {
      this.freightQueryForm.get('sroId').setValidators([Validators.required]);
      this.showSroId = true;
      this.tmssloader.show();
      this.ratesSroMasterService.getSroTypeByBusinessType(sroIdType).subscribe(sroIds => {
        this.tmssloader.hide();
        this.sroIds = AppConstants.filterSros(this.currentUser.agencyUser, this.currentUser.roles[0].name === 'Agency Auditor' ? 'System Admin' : this.currentUser.roles[0].name,
          sroIds, this.currentUser.agencyMasterId, 'FRT', this.currentUser.viewAllSro, this.currentUser.viewAllAgySro, sroIdType, this.currentUser.agencyId, this.currentUser.agencyCode);
        this.getFormField('sroId').setValidators([Validators.required]);
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('Error Getting SRO Master List. Please contact system administrator');
      });
    }
    if (sroIdType !== 'Fleet Line Vehicles Dom' && sroIdType !== 'Fleet Line Vehicles Intl') {
      this.showAccessorials = true;
    } else {
      this.showAccessorials = false;
    }

    //add fleet weight
    this.freightQueryForm.get('estimatedWeight').setErrors(null);
    this.freightQueryForm.get('estimatedWeight').clearValidators();
    this.freightQueryForm.get('estimatedWeight').setValidators([Validators.required, Validators.pattern('^[0-9]{1,8}?$')]);
    if(sroIdType.includes('Fleet')){
      this.addEstimatedWeightToFleet(value);
    }
    this.freightQueryForm.controls['estimatedWeight'].updateValueAndValidity();
  }

  updateLocation(stateCountry: StateCountry, location: string) {
    if (stateCountry.stateCountryName === 'CANADA' && location === 'origin') {
      this.canadianProvinces.pipe(filter(value => value != null))
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe(canadianProvinces => {
          this.freightQueryForm.get('originProvince').setValue(canadianProvinces);
        });
      this.freightQueryForm.controls['originProvince'].setValue(null);
      this.freightQueryForm.get('originProvince').setValidators([Validators.required]);
    } else {
      this.freightQueryForm.get('originProvince').setValidators(null);
    }

    if (stateCountry.stateCountryName === 'CANADA' && location === 'destination') {
      this.canadianProvinces.pipe(filter(value => value != null))
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe(provinces => {
          this.freightQueryForm.get('destnProvince').setValue(provinces);
        });
      this.freightQueryForm.controls['destnProvince'].setValue(null);
      this.freightQueryForm.get('destnProvince').setValidators([Validators.required]);
    } else {
      this.freightQueryForm.get('destnProvince').setValidators(null);
    }

    if (stateCountry.stateCountryName === 'CANADA' && location === 'origin') {
      this.showOriginCanadianProvince = true;
    }

    if (stateCountry.stateCountryName === 'UNITED STATES' && location === 'origin') {
      this.showOriginCanadianProvince = false;
    }

    if (stateCountry.stateCountryName === 'CANADA' && location === 'destination') {
      this.showDestCanadianProvince = true;
    }

    if (stateCountry.stateCountryName === 'UNITED STATES' && location === 'destination') {
      this.showDestCanadianProvince = false;
    }
  }

  clearValidators(formControl) {
    this.freightQueryForm.get(formControl).clearValidators();
    this.freightQueryForm.get(formControl).setValue(null);
    this.freightQueryForm.get(formControl).setErrors(null);
  }

  /**
   * @description listens to the changes of sroIdId's; pre-populates origin and destinatin based on ratesSroOriginDestinationList in sroId.
   */
  onSroIdChange() {
    // const sroId = this.getFormField('sroId').value;
    this.originList = [];
    this.destinationList = [];
    this.freightQueryForm.controls['asyncOriginSearchString'].enable();
    this.freightQueryForm.controls['asyncDestinationSearchString'].enable();
  }

  /**
   * @description gets the list of accessorails from service.
   */
  getAllAccesorials() {
    this.frtAccessorialsMasterService.getAll().subscribe(accessorials => {
      this.accessorials = accessorials;
      this.ratesSroMasterService.frtRateQueryFormState.pipe(first()).subscribe(state => {
        if (!state) {
          return;
        }
        state.sroType = this.types.find(x => x.name === state.sroType.name);
        this.setPreviousState(state);
      });
    }, (error) => {
      this.alertService.error('Error while getting accessorials');
    });
  }
// pushing the older version of the component 06/11/2024 by C Nair.//
  setPreviousState(state) {
    let index = 0;
    if (state.accessorials && state.accessorials.length > 0) {
      state.accessorials.forEach((accessorial: any) => {
        (this.freightQueryForm.get('accessorials') as FormArray).push(this.createNewAccessorial());
      });
    }

    this.arrayFormControlAccessorials = (this.freightQueryForm.get('accessorials') as FormArray).controls;
    // console.log(this.arrayFormControlAccessorials);
    for(let objs of (this.arrayFormControlAccessorials)){
      this.setValueToFormGroupAccessorial(state.accessorials[index], objs);
      index++;
    }
    this.freightQueryForm.get('pickupDate').setValue(state.pickupDate);
    this.freightQueryForm.get('sroType').setValue(state.sroType);
    this.freightQueryForm.get('sroId').setValue(state.sroId);
    this.freightQueryForm.get('estimatedWeight').setValue(state.estimatedWeight);
    this.freightQueryForm.get('numberOfVehicles').setValue(state.numberOfVehicles);
    this.freightQueryForm.get('estimatedCuFt').setValue(state.estimatedCuFt);
    this.freightQueryForm.get('originCountryId').setValue(state.originCountryId, {emitEvent: false, onlySelf: false});
    this.freightQueryForm.get('destinationCountryId').setValue(state.destinationCountryId, {emitEvent: false, onlySelf: false});
    // this.freightQueryForm.get('accessorials').setValue(state.accessorials);
    // this.addAccessorial();
    this.freightQueryForm.get('originProvince').setValue(state.originProvince, {emitEvent: false, onlySelf: false});
    this.freightQueryForm.get('destnProvince').setValue(state.destnProvince, {emitEvent: false, onlySelf: false});
    this.onSroChanges();
    if (state?.originId?.zipCode && state?.destinationId?.zipCode && state?.pickupDate && !this.isGssr) {
      this.pcMilerService(state.originId.zipCode, state.destinationId.zipCode, state.pickupDate);
    }
    this.freightQueryForm.get('asyncOriginSearchString').setValue(state.asyncOriginSearchString, {emitEvent: false, onlySelf: false});
    this.freightQueryForm.get('asyncDestinationSearchString').setValue(state.asyncDestinationSearchString, {emitEvent: false, onlySelf: false});
    this.freightQueryForm.get('originId').setValue(state.originId, {emitEvent: false, onlySelf: false});
    this.freightQueryForm.get('destinationId').setValue(state.destinationId, {emitEvent: false, onlySelf: false});
  }

  setValueToFormGroupAccessorial(singleAccessorial: any, formControlAccessorial: any){
    // console.log( formControlAccessorial.get("accessorial"));
    formControlAccessorial.get("accessorial")?.setValue(this.accessorials.find((e: any) => e.frtAccessorialsId === singleAccessorial.accessorial?.frtAccessorialsId));
    formControlAccessorial.get("units")?.setValue(singleAccessorial.units);
    formControlAccessorial.get("unitDescription")?.setValue(singleAccessorial.unitDescription);
  }

  compareAccessorialFn(c1, c2) {
    return c1 && c2 ? c1.accessorialCode === c2.accessorialCode : c1 === c2;
  }

  /**
   * @description adds accessorials form control into the form array
   */
  addAccessorial() {
    (this.freightQueryForm.get('accessorials') as UntypedFormArray).push(this.createNewAccessorial());
  }

  /**
   * @description creates accessorial form control in the form group array
   */
  createNewAccessorial(): UntypedFormGroup {
    const formGroup = this.formBuilder.group({
      accessorial: [null, [Validators.required]],
      units: [null],
      unitDescription: [null]
    });
    return formGroup;
  }

  isNameDuplicate() {
    const accessorials = this.freightQueryForm.get('accessorials').value;
    if (accessorials.length !== 0) {
      const accessorialDescriptions = accessorials.map(item => item.accessorial ? item.accessorial.accessorialDescription.replace(/ /g, '-').toUpperCase() : null);
      const selectedAccesorial = accessorialDescriptions[accessorialDescriptions.length - 1];
      accessorialDescriptions.pop();
      const hasDuplicate = accessorialDescriptions.some(
        (element) => element === selectedAccesorial
      );
      const duplications = this.isArrayConsistsDuplicates(accessorialDescriptions);
      if (hasDuplicate || duplications) {
        this.showAccessorialsError = true;
        this.freightQueryForm.get('accessorials').setErrors({ 'incorrect': true });
      } else {
        this.showAccessorialsError = false;
        this.freightQueryForm.get('accessorials').setErrors(null);
      }
    }
  }

  /**
   * @description checks if the array has duplications by converting it into a set
   */
  isArrayConsistsDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

  /**
   * @description listens to the changes in accessorials in formarray.
   * @param: event
   * @param: index
   */
  onAccessorialChange(event, index) {
    this.isNameDuplicate();
    const accessorial = this.freightQueryForm.get('accessorials')['controls'][index]['controls'].accessorial.value;
    this.tmssloader.show();
    this.frtAccessorialsMasterService.getUnitsDescriptionById(accessorial.unitsId).subscribe((units: Units) => {
      this.tmssloader.hide();
      if (units.userDisplay !== null && units.userDisplay !== undefined) {
        this.freightQueryForm.get('accessorials')['controls'][index]['controls'].unitDescription.setValue(units.userDisplay);
        this.freightQueryForm.get('accessorials')['controls'][index]['controls'].units.setValidators([Validators.required]);
      } else {
        this.freightQueryForm.get('accessorials')['controls'][index]['controls'].units.setValidators(null);
      }
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error while getting units description. please contact system administrator.');
    });
  }

  /**
   * @description removes accessorials form control from the form array at specified index
   * @param: i: index of the form control
   */
  removeAccessorial(i) {
    (this.freightQueryForm.get(
      'accessorials'
    ) as UntypedFormArray).removeAt(i);
    this.isNameDuplicate();
  }

  onWeightCubicFtChange() {
    this.showGssrError = false;
    if (this.freightQueryForm.get('estimatedWeight').value && this.freightQueryForm.get('estimatedCuFt').value) {
      const minCubicFt = (this.freightQueryForm.get('estimatedWeight').value / 40);
      this.showGssrError = !(this.freightQueryForm.get('estimatedCuFt').value >=  minCubicFt);
    }
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  changeTypeaheadDestinationLoading(e: boolean): void {
    this.typeaheadDestinationLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('originId').setValue(e.item);
  }

  typeaheadDestinationOnSelect(e: TypeaheadMatch): void {
    this.freightQueryForm.get('destinationId').setValue(e.item);
  }

  /**
   * @description saves the query and fetches the ag-grid results
   */
  saveQuery() {
    this.getUserPrefs();
    this.showQueryGrid = false;
    this.ratesSroMasterService.frtRateQueryFormState.next(this.freightQueryForm.value);
    const formValue = _.cloneDeep(this.freightQueryForm.value);
    // formValue.estimatedMileage = new RoundPipe().transform(formValue.estimatedMileage);
    const accessorials = [];
    if (formValue.originId !== null) {
      if (!formValue.originId.uspsZipId) {
        this.ratesSroMasterService.getLocation(formValue.originId.cityName,
          formValue.originId.zipCode, formValue.originId.stateAbbrev).subscribe(response => {
          formValue.originId = response.uspsZipId;
        }, error2 => {
          this.alertService.error('Error while getting the USPS zip ID of origin.');
        });
      } else {
        formValue.originId = formValue.originId.uspsZipId;
      }
    }
    if (formValue.destinationId !== null) {
      if (!formValue.destinationId.uspsZipId) {
        this.ratesSroMasterService.getLocation(formValue.destinationId.cityName,
          formValue.destinationId.zipCode, formValue.destinationId.stateAbbrev).subscribe(response => {
          formValue.destinationId = response.uspsZipId;
        }, error2 => {
          this.alertService.error('Error while getting the USPS zip ID of origin.');
        });
      } else {
        formValue.destinationId = formValue.destinationId.uspsZipId;
      }
    }
    formValue.accessorials.forEach(function (element) {
      let usage;
      let obj;
      if (AppConstants.isNotNullCondition(element) && element.accessorial.accessorialDescription.endsWith('Pickup')) {
        usage = 'Pickup';
      } else if (AppConstants.isNotNullCondition(element) && element.accessorial.accessorialDescription.endsWith('Delivery')) {
        usage = 'Delivery';
      }
      if (element.accessorial.unitsId === 9) {
        obj = {
          frtAccessorialId: element.accessorial.frtAccessorialsId,
          unitsId: element.accessorial.unitsId,
          estimatedCost: element.units === null ? 0 : element.units,
          usage: usage
        };
      } else {
        obj = {
          frtAccessorialId: element.accessorial.frtAccessorialsId,
          unitsId: element.accessorial.unitsId,
          quantity: element.units === null ? 0 : element.units,
          usage: usage
        };
      }

      accessorials.push(obj);
    });
    formValue.accessorials = accessorials;
    delete formValue.asyncDestinationSearchString;
    delete formValue.asyncOriginSearchString;
    formValue.sroType = this.freightQueryForm.get('sroType').value.name;
    formValue.autoCategory = this.freightQueryForm.get('sroType').value.sroType;
    formValue.estimatedWeight = this.freightQueryForm.get('estimatedWeight').value;
    formValue.estimatedMileage = formValue.estimatedMileage ? formValue.estimatedMileage : 0;
    formValue.numberOfVehicles = this.isFleetLineVehicle ? this.freightQueryForm.get('numberOfVehicles').value : 0;
    const pickupDate = new Date(this.freightQueryForm.value.pickupDate);
    formValue.pickupDate = pickupDate.toISOString();
    this.pickupDatePayLoad = this.freightQueryForm.value.pickupDate;
    formValue.originCountryId = this.freightQueryForm.value.originCountryId ? this.freightQueryForm.value.originCountryId.stateCountryId : null;
    formValue.destinationCountryId = this.freightQueryForm.value.destinationCountryId ? this.freightQueryForm.value.destinationCountryId.stateCountryId : null;
    formValue.destnProvince = this.freightQueryForm.value.destnProvince ? this.freightQueryForm.value.destnProvince.stateCountryId : null;
    formValue.originProvince = this.freightQueryForm.value.originProvince ? this.freightQueryForm.value.originProvince.stateCountryId : null;
    this.tmssloader.show();
    this.frtAccessorialsMasterService.getSaveFrtQueryResults(formValue).subscribe(results => {
      this.tmssloader.hide();
      this.pickupDatePayLoad = (new Date(formatDate(this.pickupDatePayLoad, this.format, this.locale)));
      this.estimatedMileage = formValue.estimatedMileage;
      this.estWeight = Number(formValue.estimatedWeight);
      this.numVehicles = Number(formValue.numberOfVehicles);
      this.queryResults$.next(results);
      this.showQueryGrid = true;
    }, error2 => {
      this.tmssloader.hide();
      this.showQueryGrid = false;
      this.alertService.error('Error while getting frt query results. Please contact system administrator.');
    });

  }

  /*
* @description getFormField for freightQueryForm
* */
  getFormField(field: string): any {
    return this.freightQueryForm.get(field);
  }

  getUserPrefs() {
    const userId = this.currentUser.userSessionEntity.userId;
    const orgId = this.currentUser.userSessionEntity.organizationId;
    const queryScreenName = 'FRTResults';

    // this.tmssloader.show();
    this.userPreferencesService.getUserPrefs(userId, orgId, queryScreenName).
    subscribe(result => {
      // this.tmssloader.hide();
      this.userPref = result;
      this.userPrefList = this.userPref.listPrefs;
      this.screenName = this.userPref.screenName;
    }, error => {
      // this.tmssloader.hide();
      this.alertService.error('Error while retreiving the user preferences');
    });

  }

  addEstimatedWeightToFleet(sroType: any){
    const fleetType = sroType.includes('Class 1')? 1 : sroType.includes('Class 2') ? 2 : 3;
    switch (fleetType){
      case 1:
        this.freightQueryForm.get('estimatedWeight').addValidators([Validators.max(5999), Validators.min(1)]);
        this.weightRanking = "Class 1: 1 - 5999";
        break;
      case 2:
        this.freightQueryForm.get('estimatedWeight').addValidators([Validators.max(11999), Validators.min(6000)]);
        this.weightRanking = "Class 2: 6000 - 11999";
        break;
      case 3:
        this.freightQueryForm.get('estimatedWeight').addValidators([Validators.min(12000)]);
        this.weightRanking = "Class 3: Minimum value is 12000";
        break;
      default:
        break;
    }
  }

  onSroChanges() {
    this.freightQueryForm.get('sroType').valueChanges
      .pipe(filter((sroIdType: any) => sroIdType?.name === 'Alternating' || sroIdType?.name === 'General' || sroIdType?.name === 'Emergency' ||
        sroIdType?.name === 'Fleet Line Vehicles Dom' || sroIdType?.name === 'Fleet Line Vehicles Intl'))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(sroIdType => {
        this.onSroTypeChange(sroIdType.name, sroIdType.sroType);
        this.freightQueryForm.get('estimatedWeight').setErrors(null);
        this.freightQueryForm.get('numberOfVehicles').setErrors(null);
        // this.freightQueryForm.get('estimatedWeight').setValidators([]);
        this.freightQueryForm.get('numberOfVehicles').setValidators([]);
        this.freightQueryForm.get('estimatedWeight').clearValidators();
        this.freightQueryForm.get('estimatedWeight').setValidators([Validators.required, Validators.pattern('^[0-9]{1,8}?$')]);
        if (sroIdType.name === 'Fleet Line Vehicles Dom' || sroIdType.name === 'Fleet Line Vehicles Intl') {
          this.isFleetLineVehicle = true;
          this.freightQueryForm.get('numberOfVehicles').setValidators([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{1,2})?$')]);
          this.addEstimatedWeightToFleet(sroIdType.sroType);
        } else {
          this.isFleetLineVehicle = false;
          // this.freightQueryForm.get('estimatedWeight').setValidators([Validators.required]);
        }
        this.freightQueryForm.updateValueAndValidity();
        if (sroIdType.name === 'Fleet Line Vehicles Intl') {
          this.showCountries = true;
        }
      });
    this.freightQueryForm.get('sroId').valueChanges.subscribe(sroId => {
      this.freightQueryForm.controls['asyncOriginSearchString'].enable();
      this.freightQueryForm.controls['asyncDestinationSearchString'].enable();
      if (sroId) {
        const selectedSroId = this.sroIds.find(s => s.sroMasterId === sroId);
        if (selectedSroId && selectedSroId.sroId === 'GSSPR') {
          this.isGssr = true;
          this.clearValidators('estimatedMileage')  ;
          this.freightQueryForm.get('estimatedCuFt').setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
        } else {
          this.isGssr = false;
          this.freightQueryForm.get('estimatedMileage').setValidators([Validators.required]);
          this.clearValidators('estimatedCuFt');
          this.freightQueryForm.get('estimatedCuFt').setValidators([Validators.pattern('^[0-9]*$')]);
        }
      }
    });
  }

  /**
   * @description listen to value changes of origin and destination values.
   */
  onValueChanges() {
    this.onSroChanges();
    this.freightQueryForm.get('originId').valueChanges.subscribe(origin => {
      // this.freightQueryForm.get('estimatedWeight').setValue(null);
      if (origin && !this.checkUserRole()) {
        if (this.freightQueryForm.get('destinationId').value) {
          const originZipCode = origin.zipCode;
          const destinationZipCode = this.freightQueryForm.get('destinationId').value.zipCode;
          const pickupDate = this.freightQueryForm.get('pickupDate').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            if (!this.checkUserRole(carrier_user) && !this.checkUserRole(carrier_user_admin) && !this.isGssr) {
              this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
            }
          }
        }
      }
    });
    this.freightQueryForm.get('destinationId').valueChanges.subscribe(destination => {
      this.freightQueryForm.get('estimatedMileage').setValue(null);
      if (destination) {
        if (this.freightQueryForm.get('originId').value) {
          const originZipCode = this.freightQueryForm.get('originId').value.zipCode;
          const destinationZipCode = destination.zipCode;
          const pickupDate = this.freightQueryForm.get('pickupDate').value;
          //const pickupdateFormatted = moment(pickupDate).format('MM/dd/yyyy');
          // calling pc miler for non carrier users only
          if (AppConstants.isNotNullCondition(this.currentUser)) {
            if (!this.checkUserRole(carrier_user) && !this.checkUserRole(carrier_user_admin) && !this.isGssr) {
              this.pcMilerService(originZipCode, destinationZipCode, pickupDate);
            }
          }
        }
      }
    });
    this.freightQueryForm.get('destinationCountryId').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(country => {
        this.freightQueryForm.get('destinationId').setValue(null);
        this.freightQueryForm.get('asyncDestinationSearchString').setValue(null);
        this.clearValidators('destinationId');
        this.clearValidators('destnProvince');
        this.freightQueryForm.get('destnProvince').setValue(null);
        if (country !== null) {
          if (country.stateCountryCode === 'US00') {
            this.showDestination = true;
            this.showOriginDestination = true;
            this.showDestCanadianProvince = false;
            this.freightQueryForm.get('destinationId').setValidators([Validators.required]);
          } else if (country.parentCountryId === 365) {
            this.showDestination = false;
            this.showDestCanadianProvince = true;
            this.freightQueryForm.get('destnProvince').setValidators([Validators.required]);
          }else {
            this.showDestination = false;
            this.showDestCanadianProvince = true;
            this.clearValidators('destinationId');
          }
        }
      });
    // originCountryId
    this.freightQueryForm.get('originCountryId').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(country => {
        this.freightQueryForm.get('originId').setValue(null);
        this.freightQueryForm.get('asyncOriginSearchString').setValue(null);
        this.freightQueryForm.get('originProvince').setValue(null);
        this.clearValidators('originId');
        this.clearValidators('originProvince');
        if (country !== null) {
          if (country.stateCountryCode === 'US00') {
            this.showOrigin = true;
            this.showOriginDestination = true;
            this.showOriginCanadianProvince = false;
            this.freightQueryForm.get('originId').setValidators([Validators.required]);
          } else if (country.parentCountryId === 365) {
            this.showOrigin = false;
            this.showOriginCanadianProvince = true;
            this.freightQueryForm.get('originProvince').setValidators([Validators.required]);
          } else {
            this.showOrigin = false;
            this.showOriginCanadianProvince = false;
            this.clearValidators('originId');
          }
        }
      });
  }

  /**
   * @description call PCMiler service to get milage
   */
  pcMilerService(originZipCode, destinationZipCode, pickUpDate) {
    if (originZipCode !== null && destinationZipCode !== null && originZipCode !== undefined && destinationZipCode !== undefined
      && originZipCode !== '' && destinationZipCode !== '') {
      this.loader.show();
      this.ratesSroMasterService.getMiles(originZipCode, destinationZipCode, 'FRT', pickUpDate.toISOString()).subscribe(estimatedMileage => {
        // this.freightQueryForm.get('estimatedMileage').patchValue(new RoundPipe().transform(estimatedMileage), {
        this.freightQueryForm.get('estimatedMileage').patchValue(estimatedMileage);
        this.loader.hide();
      }, error2 => {
        this.loader.hide();
        this.alertService.info('cannot get the mileage between the above origin and destination');
      });
    }

  }
  /**
   * @description resets all the form control values in the freight query form.
   */
  reset() {
    this.freightQueryForm.reset();
    this.freightQueryForm.patchValue({
      pickupDate: new Date(),
    });
    this.freightQueryForm.setControl('accessorials', new UntypedFormArray([]));
    this.showQueryGrid = false;
    this.sroIds = [];
    this.freightQueryForm.get('sroId').setValidators([]);
    this.ratesSroMasterService.frtRateQueryFormState.next(null);
  }
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * @description formats the date into yyyy-mm-dd format
   * @param date: Jan 01, 0000
   */
  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }
}
